import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getGalleryImages } from '../api';
import ImageLightbox from '../components/ImageLightbox';

const GalleryPage = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  const IMAGES_PER_PAGE = 20;

  useEffect(() => {
    getGalleryImages('main').then(data => {
      if (Array.isArray(data)) {
        setImages(data);
        setTotalPages(Math.ceil(data.length / IMAGES_PER_PAGE));
      }
      setLoading(false);
    }).catch(err => {
      console.error(err);
      setLoading(false);
    });
  }, []);

  const getImageUrl = (path) => {
    if (!path) return null;
    if (path.startsWith('http')) return path;
    return path;
  };

  const paginatedImages = images.slice((page - 1) * IMAGES_PER_PAGE, page * IMAGES_PER_PAGE);

  if (loading) return <div>Загрузка галереи...</div>;

  return (
    <div className="container gallery-page">
      <div className="gallery-header">
        <h1 className="section-title">Фотогалерея</h1>
        <Link to="/gallery/archives" className="btn btn-archive">
          📁 Посмотреть архив
        </Link>
      </div>
      <div className="gallery-grid">
        {paginatedImages.map((img, idx) => {
          const globalIndex = images.findIndex(i => i.id === img.id);
          return (
            <div key={img.id} className="gallery-item" onClick={() => {
              setLightboxIndex(globalIndex);
              setLightboxOpen(true);
            }}>
              <img src={getImageUrl(img.path)} alt={img.originalName} />
            </div>
          );
        })}
      </div>

      {totalPages > 1 && (
        <div className="pagination">
          <button disabled={page === 1} onClick={() => setPage(p => p - 1)}>Назад</button>
          <span>Страница {page} из {totalPages}</span>
          <button disabled={page === totalPages} onClick={() => setPage(p => p + 1)}>Вперёд</button>
        </div>
      )}

      {lightboxOpen && (
        <ImageLightbox
          images={images.map(img => getImageUrl(img.path))}
          currentIndex={lightboxIndex}
          onClose={(newIndex) => {
            if (typeof newIndex === 'number') setLightboxIndex(newIndex);
            else setLightboxOpen(false);
          }}
        />
      )}
    </div>
  );
};

export default GalleryPage;